<template>
<AuthShell>

    <v-snackbar
    :timeout="snackbar.timeout"
    :color="snackbar.color"
    v-model="snackbar.show"
    >
    {{ snackbar.message }}
    </v-snackbar>

    <v-form ref="formresetkalalaluan" @submit.prevent="resetkatalaluan">
        <div class="auth-kening">{{$t('lupakatalaluan')}}</div>
        <h2 class="auth-tajuk">Tetapkan semula kata laluan</h2>
        <!-- Menyatakan APA yang berlaku selepas menekan Hantar. Skrin lama hanya
             menunjukkan medan emel dan dua butang, jadi tiada apa yang memberitahu
             pengguna bahawa kata laluan baharu akan dihantar melalui emel. -->
        <p class="auth-nota">
            Masukkan emel akaun anda. Kata laluan baharu akan dihantar ke emel itu.
        </p>

        <v-text-field
            outlined
            color="#037769"
            prepend-inner-icon="mdi-email-outline"
            v-bind:label="$t('emel')"
            v-model="lupakatalaluanemel"
            :rules="[required('emel'), rules.email]"
        />

        <button class="auth-butang" type="submit">
            <span>{{$t('hantar')}}</span>
            <v-icon class="auth-butang__anak" size="20">mdi-arrow-right</v-icon>
        </button>

        <div class="auth-pautan auth-pautan--tengah">
            <a href="#" @click.prevent="kembali">{{$t('kembali')}}</a>
        </div>
    </v-form>

</AuthShell>
</template>
<script>
import axios from 'axios'
import i18n from '@/i18n'
import AuthShell from '@/components/AuthShell/AuthShell'
export default {
    name: 'Lupakatalaluan',
    components: {
        AuthShell
    },
    data: () => ({
        snackbar: "",
        lupakatalaluanemel: '',
        passReset:'',
        required(text){
            return (v) =>
                (v && v.length > 0) || `${i18n.t(text)} ${i18n.t('adalahdiperlukan')}`
        },
        rules: {
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || `${i18n.t('emeltidaklengkap')}`;
          }
        }
    }),
     methods:{
         kembali(){
            this.$router.push(`/${i18n.locale}/`).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
        },
         async resetkatalaluan(){
            if(this.$refs.formresetkalalaluan.validate()){
                await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/tetapkansemulakatalaluan`, {
                    lupakatalaluanemel: this.lupakatalaluanemel,
                })
                .then(response =>{
                    var pss = response.data.pswrd;
                    if(!response.data.status){
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: `${i18n.t('emelxwujud')}`,
                            timeout: 2000
                        })
                    } else {
                        alert(`Katalaluan di hantar ke ${this.lupakatalaluanemel} password : `+pss)
                        // this.snackbar = {
                        //     message: i18n.t("katalaluantelahdihantar"),
                        //     timeout: 2000,
                        //     color: "success",
                        //     show: true,
                        // };
                            this.$router.push(`/${i18n.locale}/`).catch(err => {
                            if (err.name !== 'NavigationDuplicated') {
                                throw err;
                            }
                        });
                    }


                    console.log(response.data.status)
                })
                .catch(error => {
                    console.log(error)
                    alert(error)
                })
            }
         }
     }
}
</script>

<style scoped>
/* Halaman ini tiada medan kedua untuk menyandarkan pautan ke kanan, jadi
   "Kembali" duduk di tengah di bawah butang utama — jalur simetri di bawah
   satu tindakan, bukan pautan yang tergantung di birai. Margin positif kerana
   ia mengikut butang, bukan ruang mesej medan. */
.auth-pautan--tengah {
  margin: 18px 0 0;
  text-align: center;
}
</style>
